import { Trophy } from "lucide-react";
import { Link, useLocation, useParams } from "react-router-dom";

import PageHeader from "../../Components/PageHeader";
import PublishedLeaderboard from "../../Container/PublishedLeaderboard";
import { normalizeRoleName } from "../../Utils/Constants/RoleConstants";
import { discoveryHubReturnPath } from "../../Utils/Helper/discoveryHubUi";
import {
  STORAGE_KEYS,
  getFromLocalStorage,
} from "../../Utils/Helper/LocalStorage";

import "./style.scss";

const LeaderboardPage = () => {
  const location = useLocation();
  const { orgSlug } = useParams<{ orgSlug?: string }>();
  const navState = location.state as {
    fromDraftLeaderboard?: boolean;
    breadcrumbDraftUrl?: string;
    breadcrumbHubUrl?: string;
  } | null;
  const fromDraftLeaderboard = Boolean(navState?.fromDraftLeaderboard);

  const withOrg = (path: string) => {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return orgSlug ? `/${orgSlug}${normalizedPath}` : normalizedPath;
  };

  const loggedIn = getFromLocalStorage(STORAGE_KEYS.LOGGED_IN_USER);
  const userRole = normalizeRoleName(loggedIn?.role);
  // Prefer the exact origin URLs captured when leaving the Draft Leaderboard
  // (restores tab state); fall back to a role-derived path otherwise.
  const discoveryHubUrl =
    navState?.breadcrumbHubUrl ||
    withOrg(discoveryHubReturnPath(userRole, "ongoing"));
  const draftLeaderboardUrl =
    navState?.breadcrumbDraftUrl ||
    withOrg(discoveryHubReturnPath(userRole, "draft-leaderboard"));

  return (
    <div className="leaderboard-page leaderboard-page--standalone bg-white mt-3 min-w-0">
      <PageHeader
        title="Sponsor Engagement Leaderboard"
        icon={Trophy}
        className="page-header"
      />

      {fromDraftLeaderboard ? (
        <nav
          aria-label="Breadcrumb"
          className="border-b border-gray-200 bg-white px-5 py-3"
        >
          <ol className="flex items-center gap-2 text-sm">
            <li>
              <Link
                to={discoveryHubUrl}
                className="font-medium text-gray-500 hover:text-purple-700 transition-colors"
              >
                Discovery Hub
              </Link>
            </li>

            <li className="text-gray-400" aria-hidden>
              &gt;
            </li>

            <li>
              <Link
                to={draftLeaderboardUrl}
                className="font-medium text-gray-500 hover:text-purple-700 transition-colors"
              >
                Draft Leaderboard
              </Link>
            </li>

            <li className="text-gray-400" aria-hidden>
              &gt;
            </li>

            <li className="font-semibold text-gray-900" aria-current="page">
              Leaderboard
            </li>
          </ol>
        </nav>
      ) : null}

      <div className="w-full bg-white p-3 md:p-4">
        <div className="leaderboard-page__content rounded-md bg-gray-100 p-4 md:p-4">
          <PublishedLeaderboard embedded />
        </div>
      </div>
    </div>
  );
};

export default LeaderboardPage;
